import { createContext, useEffect, useState } from "react";
import GetLocalStorageValue from "../Reusable/GetLocalStorageValue";
import { BaseURL } from "../Reusable/BaseURL";

const UserContext = createContext({});

const UserContextProvider = ({ children }) => {
  const [darkTheme, setDarkTheme] = useState(false);
  const [loginData, setLoginData] = useState({});
  const [loginDataLoading, setLoginDataLoading] = useState(true);
  const [isHeaderMenuOpen, setIsHeaderMenuOpen] = useState(false);
  const [indentAddItemLoading, setIndentAddItemLoading] = useState(false);
  const [indentCreateItemId4Upd, setIndentCreateItemId4Upd] = useState(0);

  const [allPermiss, setAllPermiss] = useState([]);

  // indent update data context
  const [indentUpdateData, setIndentUpdateData] = useState({});
  const [indentUpdateDataItems, setIndentUpdateDataItems] = useState([]);

  // direct po update data context
  const [directPOUpdateData, setDirectPOUpdateData] = useState({});
  const [directPOUpdateDataItems, setDirectPOUpdateDataItems] = useState([]);

  const [quotationPartyId, setQuotationPartyId] = useState(0);
  const [quotationIndentId, setQuotationIndentId] = useState(0);

  // indent po cache data
  const [indentPOCache, setIndentPOCache] = useState([]);
  // GATE PASS LIST: data
  const [gatePassListData, setGatePassListData] = useState([]);

  // HEADER SUBMENU
  const [selectedMenu, setSelectedMenu] = useState(null);

  // CREATE USER PERMISSIONS DATA:
  const [permisData, setPermisData] = useState({});

  useEffect(() => {
    setLoginDataLoading(true);
    const localStorageData = GetLocalStorageValue("vazronLoginData", {});
    setLoginData(localStorageData);
    // console.log("contextLoginDAta", localStorageData)
    if (!loginData?.token) {
      setLoginDataLoading(false);
    }
  }, []);

  useEffect(()=>{
    setAllPermiss(loginData?.permissions)
  },[loginData?.permissions])

  if (loginDataLoading) {
    return (
      <div className={"pt-[20%] h-screen text-center bg-[#ffffff]"}>
        <span className={"loader"}></span>
      </div>
    );
    // return "loading user info..";
  }

  return (
    <UserContext.Provider
      value={{
        darkTheme,
        setDarkTheme,
        loginData,
        setLoginData,
        allPermiss,
        setAllPermiss,
        loginDataLoading,
        setLoginDataLoading,
        isHeaderMenuOpen,
        setIsHeaderMenuOpen,
        indentAddItemLoading,
        setIndentAddItemLoading,
        setIndentCreateItemId4Upd,
        indentCreateItemId4Upd,
        indentUpdateData,
        setIndentUpdateData,
        indentUpdateDataItems,
        setIndentUpdateDataItems,
        quotationIndentId,
        setQuotationIndentId,
        quotationPartyId,
        setQuotationPartyId,
        setDirectPOUpdateDataItems,
        directPOUpdateDataItems,
        directPOUpdateData,
        setDirectPOUpdateData,
        indentPOCache,
        setIndentPOCache,

        gatePassListData,
        setGatePassListData,
        setSelectedMenu,
        selectedMenu,

        permisData,
        setPermisData,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export { UserContext, UserContextProvider };
